import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';

import { ModalNames, useModals } from 'src/components/modals';
import { ENROLLMENT_EVENTS, useDutchiePayAnalytics } from '../hooks';

type WhatIsPayByBankProps = {
  className?: string;
  ctaText?: string;
  textDecoration?: boolean;
};

export const WhatIsPayByBank = ({
  className,
  ctaText = 'What is Pay by Bank?',
  textDecoration = true,
}: WhatIsPayByBankProps): JSX.Element => {
  const { openModal } = useModals();
  const { dutchiePayEventTracker } = useDutchiePayAnalytics();

  const handleOpenDutchiePayCtaModal = useCallback(async (): Promise<void> => {
    dutchiePayEventTracker(ENROLLMENT_EVENTS.CTA_BUTTON_CLICKED);

    void openModal(ModalNames.dutchiePayCta);
  }, [dutchiePayEventTracker, openModal]);

  return (
    <LinkText className={className} onClick={handleOpenDutchiePayCtaModal} $textDecoration={textDecoration}>
      {ctaText}
    </LinkText>
  );
};

const LinkText = styled.button<{ $textDecoration?: boolean }>`
  ${({ theme: { customized } }) => css`
    background: transparent;
    text-decoration: ${({ $textDecoration }) => ($textDecoration ? 'underline' : 'none')};
    border: none;
    cursor: pointer;
    color: #646d72;
    text-align: center;
    font: 11px/14px Matter;

    &:hover {
      color: ${customized.colors.buttonsLinks};
    }
  `}
`;
